<template>
  <v-dialog max-width="500" :model-value="isVisible" persistent>
    <v-card :title="`Add enterprise member for (${customer?.company})`">
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            name="email"
            label="Email"
            type="text"
            autocomplete="none"
            validate-on="blur"
            :maxLength="254"
            v-model="email"
            :rules="[rules.required, rules.email]"
            variant="outlined"
            density="default"
          >
          </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded="lg" size="large" variant="outlined" color="gray" @click="cancel" :disabled="isLoading">
          Cancel
        </v-btn>
        <v-btn rounded="lg" size="large" color="#363a40" variant="flat" @click="save" :loading="isLoading">
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validateEmail } from '@/utils/validate'
import { mapState } from 'vuex'

export default {
  name: 'UnsavedCommentsDialog',
  props: {
    customer: {
      type: Object,
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  emits: ['save', 'cancel'],
  data: () => ({
    valid: true,
    email: '',
    rules: {
      required: (value) => !!value || 'Required.',
      email: (value) => {
        return validateEmail(value) || 'Invalid e-mail.'
      }
    }
  }),
  computed: {
    ...mapState({
      users: state => state.user.users,
      loadingAddEnterpriseMember: state => state.enterpriseCustomers.loadingAddEnterpriseMember
    })
  },
  methods: {
    async save () {
      const { valid } = await this.$refs.form.validate()
      if (valid) {
        this.$emit('save', {
          id: this.customer.payerUser.id,
          email: this.email
        })
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  mounted () {
    this.$store.dispatch('user/listUsers')
  },
  watch: {
    users (users) {
      this.payerUserEmails = (users || []).filter(user => user?.stripeCustomerId && user?.stripeCustomerId.startsWith('ecus_')).map(user => user.email)
    },
    customer: function (customer) {
      if (customer) {
        this.company = customer.company
      } else {
        this.$refs.form.reset()
      }
    }
  }
}
</script>
